export const COLLECTORS = [
  {
    key: "dallas",
    name: "Dallas County 🟢",
    region: "North Texas",
    idType: "Account #",
    detail: "Digits and letters ok",
    comingSoon: false,
  },
  {
    key: "collin",
    name: "Collin County 🟡",
    region: "North Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "bexar",
    name: "Bexar County 🟡",
    region: "South Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "travis",
    name: "Travis County 🟡",
    region: "Central Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "smith",
    name: "Smith County 🟢",
    region: "Northeast Texas",
    idType: "PIN #",
    detail: "PIN must start with a letter",
  },
  {
    key: "denton",
    name: "Denton County 🟡",
    region: "North Texas",
    idType: "Account #",
    detail: "Digits only",
  },
  {
    key: "hcad",
    name: "Harris County 🟡",
    aliases: ["harris", "harris county", "harris cad", "hcad"],
    region: "Southeast Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "lubbock",
    name: "Lubbock County 🟢",
    region: "West Texas",
    idType: "QuickRef ID",
    detail: "Starts with a letter (e.g. R172447)",
  },
  {
    key: "hidalgo",
    name: "Hidalgo County 🟡",
    region: "South Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "cameron",
    name: "Cameron County 🟡",
    region: "South Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "jefferson",
    name: "Jefferson County 🟢",
    region: "Southeast Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "victoria",
    name: "Victoria County 🟢",
    region: "South Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "wichita",
    name: "Wichita County 🟢",
    region: "North Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "comal",
    name: "Comal County 🟢",
    region: "Central Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "rockwall",
    name: "Rockwall County 🟡",
    region: "North Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "montgomery",
    name: "Montgomery County 🟡",
    region: "Southeast Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: true,
  },
  {
    key: "bell",
    name: "Bell County 🟢",
    region: "Central Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "galveston",
    name: "Galveston County 🟡",
    region: "Southeast Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: true,
  },
  {
    key: "nueces",
    name: "Nueces County 🟡",
    region: "South Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: true,
  },
  {
    key: "fortbend",
    name: "Fort Bend County 🟡",
    region: "Southeast Texas",
    idType: "Account #",
    detail: "Letters + digits ok (e.g. R216777)",
    comingSoon: false,
  },
  // ---- Tier 1 BIS eSearch additions ----
  {
    key: "brazoria",
    name: "Brazoria County 🟡",
    region: "Southeast Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "hays",
    name: "Hays County 🟡",
    region: "Central Texas",
    idType: "QuickRef ID",
    detail: "Letters + digits ok (e.g. R190252)",
    comingSoon: false,
  },
  {
    key: "grayson",
    name: "Grayson County 🟡",
    region: "North Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "kaufman",
    name: "Kaufman County 🟡",
    region: "North Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "wilson",
    name: "Wilson County 🟡",
    region: "South Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  {
    key: "wise",
    name: "Wise County 🟡",
    region: "North Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
  },
  // ---- Tarrant (Prodigy API — requires portal login) ----
  {
    key: "tarrant",
    name: "Tarrant County 🟡",
    aliases: ["tarrant", "tarrant county", "tarrant cad", "tad"],
    region: "North Texas",
    idType: "Account #",
    detail: "Digits only",
    comingSoon: false,
    requiresAuth: true,
  },
];
